import { ReactNode } from 'react';

interface AppBackgroundProps {
  children: ReactNode;
}

export function AppBackground({ children }: AppBackgroundProps) {
  return (
    <div
      className="relative min-h-screen overflow-clip text-foreground bg-background"
      style={{ background: 'var(--canvas-gradient)' }}
    >
      <div
        className="fixed inset-0 pointer-events-none"
        aria-hidden
        style={{ background: 'var(--canvas-tint-gradient)' }}
      />
      <div className="relative min-h-screen">{children}</div>
    </div>
  );
}